import { render, staticRenderFns } from "./OutstandingAccountReceivables.vue?vue&type=template&id=8363f070&"
import script from "./OutstandingAccountReceivables.vue?vue&type=script&lang=js&"
export * from "./OutstandingAccountReceivables.vue?vue&type=script&lang=js&"
import style0 from "./OutstandingAccountReceivables.vue?vue&type=style&index=0&id=8363f070&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports